import type { Testimonial } from '../types/content';

export const testimonials: Testimonial[] = [
  {
    market: 'commercial',
    quote: {
      en: 'Win21der repainted all three floors of our office over two weekends. Zero disruption to our staff, crisp lines everywhere, and they left the space cleaner than they found it.',
      es: 'Win21der repintó los tres pisos de nuestra oficina en dos fines de semana. Cero interrupciones para el personal, líneas perfectas y dejaron el espacio más limpio de lo que lo encontraron.',
    },
    name: 'Michael Reyes',
    role: { en: 'Facilities Director', es: 'Director de Instalaciones' },
    company: 'Northpoint Insurance Group',
    city: 'Dublin, OH',
  },
  {
    market: 'residential',
    quote: {
      en: "They painted our entire house interior in just 5 days. The attention to detail is amazing, from trim to ceilings. We couldn't be happier with our home.",
      es: 'Pintaron todo el interior de nuestra casa en solo 5 días. La atención al detalle es increíble, desde las molduras hasta los techos. No podríamos estar más felices con nuestro hogar.',
    },
    name: 'Sarah Martinez',
    role: { en: 'Homeowner', es: 'Propietaria' },
    city: 'Dublin, OH',
  },
  {
    market: 'commercial',
    quote: {
      en: 'From estimate to final walkthrough they were professional and on time. Our storefront looks brand new and customers noticed immediately.',
      es: 'Desde el presupuesto hasta la revisión final fueron profesionales y puntuales. Nuestra fachada luce como nueva y los clientes lo notaron de inmediato.',
    },
    name: 'Priya Patel',
    role: { en: 'Owner', es: 'Propietaria' },
    company: 'Linden Market & Café',
    city: 'Columbus, OH',
  },
  {
    market: 'residential',
    quote: {
      en: 'They painted my deck and exterior trim. The quality is exceptional and it looks like a brand new house. Highly recommend!',
      es: 'Pintaron mi terraza y las molduras exteriores. La calidad es excepcional y la casa parece nueva. ¡Muy recomendados!',
    },
    name: 'James Thompson',
    role: { en: 'Homeowner', es: 'Propietario' },
    city: 'Westerville, OH',
  },
  {
    market: 'commercial',
    quote: {
      en: 'They painted our sanctuary and fellowship hall and now the whole building feels fresh and welcoming. Professional, respectful, and fairly priced.',
      es: 'Pintaron nuestro santuario y el salón de convivencia, y ahora todo el edificio se siente renovado y acogedor. Profesionales, respetuosos y con precios justos.',
    },
    name: 'Pastor David',
    role: { en: 'Senior Pastor', es: 'Pastor Principal' },
    company: 'New Hope Community Church',
    city: 'Columbus, OH',
  },
];
